import React from "react";
import { RESERVATION_COLOR } from "../../constants";

const LEGEND_ITEMS = [
  { color: "#FFD700", label: "VIP" },
  { color: RESERVATION_COLOR, label: "PDR" },
  { color: "#D90429", label: "Allergies" },
  { color: "#1BC5BD", label: "Pre-paid" },
  { color: "#FF7F00", label: "Pending" },
  { color: "#D1D3E0", border: "1px solid #333", label: "Standard" },
];

const ReservationLegend = ({ className = "", fontSize = "0.8rem" }) => (
  <div
    className={`d-flex flex-wrap align-items-center d-print-none ${className}`}
  >
    {LEGEND_ITEMS.map((item) => (
      <div key={item.label} className="d-flex align-items-center mr-4">
        <div
          style={{
            width: "14px",
            height: "14px",
            borderRadius: "50%",
            marginRight: "8px",
            border: item.border,
            display: "flex",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", backgroundColor: item.color }}></div>
        </div>
        <span style={{ fontSize }}>{item.label}</span>
      </div>
    ))}
  </div>
);

export default ReservationLegend;
